<template>
	<div>
		<a-spin :spinning="loading" tip="Loading...">
			<CountrySelect ref="countrySelect" v-model="countryList" :getData="search" multiple style="padding-bottom: 0px"
				placeholder="您想看哪个国家&地区的趋势？最多选6个"
			></CountrySelect>
			<CategorySelect v-model="categoryCode" :getData="search"
				placeholder="您想看品类或子类的趋势？"
			></CategorySelect>
			<div class="chart-box">
				<a-row class="filter" type="flex" justify="space-between" style="margin-bottom: 10px">
					<a-col>
						<span>核心指标：</span>
						<a-select
							v-model="exportType"
							style="width: 120px"
							@change="search"
						>
							<a-select-option value="5">花费指数</a-select-option>
							<a-select-option value="2">展示指数</a-select-option>
							<a-select-option value="1">点击指数</a-select-option>
							<a-select-option value="4">CTR</a-select-option>
							<a-select-option value="3">CPC</a-select-option>
							<a-select-option value="6">CPM</a-select-option>
						</a-select>
						<span style="margin-left: 24px">时间维度：</span>
						<a-select
							v-model="dateDimension"
							style="width: 120px"
							@change="search"
						>
							<a-select-option value="0">天</a-select-option>
							<a-select-option value="1">周</a-select-option>
							<a-select-option value="2">月</a-select-option>
							<a-select-option value="3">季</a-select-option>
						</a-select>
						<span style="margin-left: 24px">时间范围：</span>
						<TagDateRange style="width: 250px" v-model="dateRange" :getList="getList" tdDisabled></TagDateRange>
					</a-col>
				</a-row>
				<v-chart ref="barchart" :options="options" autoresize style="width: 100%"/>
			</div>
		</a-spin>
	</div>
</template>
<script>
import { trendByCountry, queryTrendCountry } from '@/api/template'
import mixin from './rankMixin.js'
import TagDateRange from "@/components/TagDateRange";
import CategorySelect from './categorySelect'
import CountrySelect from './countrySelect'
import moment from 'moment';

const columns = [
	{
		title: '国家',
		dataIndex: 'cname',
		width: 250,
		align: 'left',
	},
]
export default {
	name: 'CountryTrend',
	mixins: [mixin],
	data() {
		return {
			exportType: '5',
			dateDimension: '1',
			data: [],
			categoryCode: 'ALL',
			countryList: [],
      dateRange: [moment().subtract(30, 'days').format('YYYY-MM-DD'), moment().subtract(1, 'days').format('YYYY-MM-DD')],
		}
	},
	props: ['mediaType'],
	components: {
		CategorySelect,
		CountrySelect,
		TagDateRange
	},
	computed: {
		columns() {
			let obj = {
				title: this.exportTypeMap[this.exportType].name,
				dataIndex: this.exportTypeMap[this.exportType].value,
				width: 250,
				align: 'right',
				scopedSlots: { customRender: 'number' },
			}
			return [...columns, obj]
		}
	},
	methods: {
		getList() {
      this.loading = true
			this.data = []
			this.options.xAxis[0].data = []
			this.options.series = []
			this.options.dataZoom[0].show = false   
      trendByCountry({
				pageSize: this.pagination.pageSize,
        pageNo: this.pagination.current,
				categoryCode: this.categoryCode == 'ALL'?undefined:this.categoryCode,
				countryList: this.countryList,
				exportType: this.exportType,
				dateDimension: this.dateDimension,
				startDate: this.dateRange[0],
				endDate: this.dateRange[1],
				mediaType: this.mediaType,
      }).then((res) => {
				this.data = res.data || []
				let options = JSON.parse(JSON.stringify(this.options))
				for (let i = 0; i < this.data.length; i++) {
					const ele = this.data[i];
					options.series[i] = {
						data: [],
						type: "line",
						itemStyle: {
							borderRadius: null,
							color: this.$enum.ChartOptionsColor[i],
							barBorderRadius: [4, 4, 0, 0],
						},
					}
					options.series[i].name = ele.country
					options.xAxis[0].data = ele.countryTrendDataList.map(v => v.dateX)
					options.series[i].data = ele.countryTrendDataList.map(v => v[this.exportTypeMap[this.exportType].value])
				}
				options.yAxis[0].axisLabel.formatter = '{value}' + this.exportTypeMap[this.exportType].unit
				options.dataZoom[0].show = options.xAxis[0].data.length > 11
				this.options = options
				console.log(this.options)
      }).finally(() => this.loading = false)
    },
		queryTrendCountry() {
      this.loading = true
			queryTrendCountry().then(res => {
				this.countryList = res.data.map(v => v.dkey)
				this.$refs.countrySelect.addCache(res.data || [])
				this.getList()
			})
		}
	},
	mounted() {
		this.queryTrendCountry()
	},
}
</script>
<style lang="less" scoped>
.export-btn {
	margin-right: 24px;
}
</style>